module.exports = __webpack_public_path__ + "static/media/question.a85f8332.svg";